import { useOpenOrders, useOrders } from '@/features/account/api/get-orders';
import { useAccountStore } from '@/store/use-account-store';
import {
  cloneDefaultWalletScopedOrders,
  useOrdersStore,
} from '@/store/use-orders-store';
import {
  handleOrderForStore,
  orderResponseToOrder,
} from '@/utils/handle-store-data';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

export default function AccountHandler() {
  const {
    data: openOrders,
    isPending: areOrdersPending,
    isRefetching: areOrdersRefetching,
  } = useOpenOrders();

  useEffect(() => {
    if (!openOrders) return;
    const { address } = useAccountStore.getState();
    if (!address) return;
    openOrders.forEach((res) => {
      const order = orderResponseToOrder(res);
      handleOrderForStore(order, { skipFill: true, address });
    });
    const storedOrders =
      useOrdersStore.getState().byWallet[address]?.orders ?? {};
    const newOrderIds = new Set(
      openOrders.map((res) => res.id).filter((id) => id in storedOrders),
    );
    // Remove existing store new orders that are no longer open
    useOrdersStore.setState((state) => ({
      byWallet: {
        ...state.byWallet,
        [address]: {
          ...cloneDefaultWalletScopedOrders(),
          ...(state.byWallet[address] ?? {}),
          newOrderIds,
        },
      },
    }));
  }, [openOrders]);

  const address = useAccountStore((state) => state.address);
  const refetchInterval = useOrdersStore((state) => state.refetchInterval);
  const openOrdersIds = useOrdersStore(
    useShallow((state) => Array.from(state.getOrders(address).newOrderIds)),
  );

  useOrders({
    id: openOrdersIds,
    onSuccess: (res) =>
      res.forEach((data) => handleOrderForStore(orderResponseToOrder(data))),
    queryConfig: {
      enabled:
        !areOrdersPending && !areOrdersRefetching && openOrdersIds.length > 0,
      refetchInterval,
      refetchOnMount: false,
    },
  });

  return <></>;
}
